/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";
import { getLabel } from "Utils";

/**
 * Import required elements
 */
// Material-ui components
import { Typography, IconButton } from "@material-ui/core";
// Material-ui icons
import BackIcon from "@material-ui/icons/ChevronLeft";

import styles from "./styles";

/**
 * Header Component
 */
function Header({ title, back, lang }) {
  function getBack(event) {
    event.preventDefault();
    if (back) back();
  }

  // CSS classnames
  const classes = styles();

  return (
    <div className={classes.header}>
      {back && (
        <IconButton
          className={classes.backButton}
          onClick={getBack}
          size="small"
        >
          <BackIcon fontSize="inherit" />
        </IconButton>
      )}
      <Typography>
        {getLabel(title, lang, "Footer/NewChat/Category/Header")}
      </Typography>
    </div>
  );
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang
}))(Header);
